import './index.less'


// WEBPACK FOOTER //
// ./ecology9/base/wea-transfer-right/style/index.js